var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 57,
    viewBox: "0 0 56 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/link/linkedin"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M37.3333 16.2871C38.0406 16.2871 38.7189 16.5681 39.219 17.0682C39.719 17.5683 40 18.2465 40 18.9538V37.6204C40 38.3277 39.719 39.006 39.219 39.5061C38.7189 40.0062 38.0406 40.2871 37.3333 40.2871H18.6667C17.9594 40.2871 17.2811 40.0062 16.781 39.5061C16.281 39.006 16 38.3277 16 37.6204V18.9538C16 18.2465 16.281 17.5683 16.781 17.0682C17.2811 16.5681 17.9594 16.2871 18.6667 16.2871H37.3333ZM36.6667 36.9538V29.8871C36.6667 28.7343 36.2087 27.6287 35.3936 26.8136C34.5784 25.9984 33.4728 25.5404 32.32 25.5404C31.1867 25.5404 29.8667 26.2338 29.2267 27.2738V25.7938H25.5067V36.9538H29.2267V30.3804C29.2267 29.3538 30.0533 28.5138 31.08 28.5138C31.5751 28.5138 32.0499 28.7104 32.3999 29.0605C32.75 29.4106 32.9467 29.8854 32.9467 30.3804V36.9538H36.6667ZM21.1733 23.7004C21.7674 23.7004 22.3372 23.4644 22.7573 23.0444C23.1773 22.6243 23.4133 22.0545 23.4133 21.4604C23.4133 20.2204 22.4133 19.2071 21.1733 19.2071C20.5757 19.2071 20.0026 19.4445 19.58 19.8671C19.1574 20.2897 18.92 20.8628 18.92 21.4604C18.92 22.7004 19.9333 23.7004 21.1733 23.7004ZM23.0267 36.9538V25.7938H19.3333V36.9538H23.0267Z",
    fill: "#CCCCCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.1690cc30c3db7ebb42b3765128d94dd2.svg";
export { ForwardRef as ReactComponent };